import { trueFitConfig } from '../config';
import { captureException } from '@sentry/nextjs';

export default async function fetchToken(locale: string): Promise<string> {
    try {
        const response = await fetch(
            `${trueFitConfig.getAPIBaseURL(
                locale
            )}${trueFitConfig.tokenEndpoint(locale)}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Client-ID': trueFitConfig.getClientID(locale) || '',
                },
                credentials: 'include',
            }
        );

        if (!response.ok) {
            throw new Error(
                `Failed to fetch True Fit token: ${response.statusText}`
            );
        }

        const token = response.headers.get('x-tf-usertoken');
        if (token) {
            localStorage.setItem('trueFitToken', token);
            return token;
        } else {
            throw new Error('No token received from True Fit API');
        }
    } catch (error) {
        console.error('Error fetching token:', error);
        captureException(error);
        throw error;
    }
}
